(function (Drupal,) {
  Drupal.behaviors.searchHeader = {
    attach(context) {
      const menuEl = context.querySelector('.main-menu');
      const searchBtn = context.querySelector('.main-menu .open-search');
      const searchClose = context.querySelector('.main-menu .close-search');
      const searchInput = context.querySelector('.main-menu form input');

      if (searchBtn && menuEl) {
        searchBtn.addEventListener('click', () => {
          menuEl.classList.add('search-is-open');
          searchInput.focus();
        });
      }

      if (searchClose && menuEl) {
        searchClose.addEventListener('click', () => {
          menuEl.classList.remove('search-is-open');
        });
      }
    },
  };
})(Drupal);
